import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Button,
  Grid,
} from 'antd';

import {
  ArrowLeftOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons';

const ModalDeactivatedControls = ({ onCancel, onDeactivate, loading }) => {
  const screens = Grid.useBreakpoint();
  return (
    <Row className="form-submit-controls">
      <Button
        type="link"
        onClick={onCancel}
        disabled={loading}
      >
        <ArrowLeftOutlined />
        {screens.md && 'Cancelar'}
      </Button>
      <Button
        type="link"
        onClick={onDeactivate}
        disabled={loading}
        style={{ marginLeft: 10 }}
        className="submit-delete"
        autoFocus
      >
        <MinusCircleOutlined />
        {screens.md && 'Desactivar'}
      </Button>
    </Row>
  );
};

ModalDeactivatedControls.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onDeactivate: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

ModalDeactivatedControls.defaultProps = {
  loading: false,
};

export default ModalDeactivatedControls;
